import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import check from '../../../../../assets/images/unsibscribe/check.svg';

export const useStyles = makeStyles(({
  borderRadiuses, palette, breakpoints,
}: Theme) => ({
  root: {
    padding: '0 1rem',
    [breakpoints.up('md')]: {
      maxWidth: '46.375rem',
      margin: '0 auto',
    },
    [breakpoints.up('lg')]: {
      maxWidth: '57.25rem',
    },
  },
  groupStyles: {
    gap: '0.5rem',
    justifyContent: 'center',
    '&&& .MuiButtonBase-root': {
      justifyContent: 'flex-start',
      width: '100%',
      margin: 0,
      padding: '3px 0.75rem 3px 1.625rem',
      borderRadius: '0.75rem',
      fontSize: '0.875rem',
      lineHeight: '1.4',
      [breakpoints.up('md')]: {
        width: 'fit-content',
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '0.25rem',
        left: '0.25rem',
        width: '1.125rem',
        height: '1.125rem',
        borderRadius: borderRadiuses.xxl,
        backgroundColor: 'rgba(34, 34, 34, 0.1)',
      },
      '&.Mui-selected': {
        borderColor: palette.info.dark,
        backgroundColor: palette.info.dark,
        color: palette.common.white,
        '&::before': {
          content: '""',
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '0.75rem auto',
          backgroundImage: `url('${check}')`,
        },
      },
      '& span': {
        textAlign: 'left',
      },
    },
  },
  groupWrapper: {
    marginBottom: '0.5rem',
  },
  other: {
    '& .MuiInputBase-root': {
      maxWidth: '25rem',
      padding: '0.25rem 0.75rem',
      borderRadius: '0.75rem',
      border: `1px solid ${palette.grey[400]}`,
      backgroundColor: palette.grey[200],
      boxShadow: '0 0.25rem 0.25rem 0 rgba(0, 0, 0, 0.05) inset',
      fontSize: '0.875rem',
      lineHeight: '1.4',
      [breakpoints.up('md')]: {
        margin: '0 auto',
      },
      '&::before, &::after': {
        display: 'none',
      },
      '& .MuiInputBase-input': {
        padding: 0,
        color: '#737373',
        '&::placeholder': {
          color: '#737373',
        },
      },
    },
  },
  nowrap: {
    whiteSpace: 'nowrap',
  },
}));
